import { Button, styled, Typography } from "@mui/material";

export const StyledTasksFilterContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#fff",
  border: "1px solid rgba(0,0,0,0.08)",
  borderRadius: "12px",
  padding: "8px 12px",
}));
export const StyledClientFilterItem = styled(Typography)<{ active: number }>(
  ({ active, theme }) => ({
    transition: "background-color 0.2s, color 0.2s",
    cursor: "pointer",
    borderRadius: "10px",
    padding: theme.spacing(0.5, 1.5),
    fontWeight: active ? 600 : 400,
    background: active ? theme.palette.primary.main : "transparent",
    color: active ? "#fff" : "rgba(0,0,0,0.6)",
    "&:hover": {
      background: active ? theme.palette.primary.main : "rgba(0,0,0,0.06)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.5, 1),
    },
    display: "flex",
    alignItems: "center",
  })
);

export const StyledMoreHorButton = styled(Button)(({ theme }) => ({
  background: "transparent",
  minWidth: 0,
  padding: 0,
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  color: "rgba(0,0,0,0.5)",
  "&:hover": {
    background: "rgba(0,0,0,0.06)",
  },
}));

export const StyledAppliedFilterItem = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 6,
  background: "rgba(0,0,0,0.045)",
  borderRadius: "999px",
  padding: "5px 6px 5px 12px",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  transition: "background-color 0.15s",
  "&:hover": {
    background: "rgba(0,0,0,0.09)",
  },
}));

export const StyledFilterCloseButton = styled("span")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 18,
  height: 18,
  borderRadius: "50%",
  transition: "background-color 0.15s",
  "&:hover": {
    background: "rgba(0,0,0,0.12)",
  },
});
